import React from "react";
import { useAuth } from "@/lib/AuthContext";
import { useNavigate } from "react-router-dom";
import AppHeader from "@/components/drill/AppHeader";
import AdminAuditLogs from "@/components/drill/AdminAuditLogs";
import { isAtLeast } from "@/lib/roles";

export default function AdminAuditLogsPage() {
  const { effectiveRole } = useAuth();
  const navigate = useNavigate();

  if (!isAtLeast(effectiveRole, "admin")) {
    return (
      <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-6">
        <div className="text-center space-y-4">
          <p className="text-slate-600 dark:text-slate-300">Admin access required.</p>
          <button className="underline" onClick={() => navigate("/")}>Return Home</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      <AppHeader title="Audit Logs" subtitle="Admin activity and data-change history" backTo="/" />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6 pb-24">
        <AdminAuditLogs />
      </main>
    </div>
  );
}
